<template>
  <section id="kelas-iklim">
    <Header :scrolled="true"/>
    <div class="pageInfo bumiKini">
      <div class="loadingCoverImg" v-if="loading"></div>
      <div class="coverImg" :style="{'background-image': `url(${detail.thumbData.imageLg})`}"
        v-else-if="detail && detail.thumbData"></div>
      <div class="pageInfoWrapper">
        <div class="topBg"></div>
        <div class="pageInfoWrapper2">
          <div class="worCnt tenggelamDalamDiam">
            <div class="ilLeft sendal"></div>
            <div class="ilLeft boneka"></div>
            <div class="ilLeft ranting"></div>
            <div class="ilRight lemari"></div>
            <div class="ilRight botol"></div>
            <div class="ilRight ranting"></div>
            <!-- <h2>Mengabarkan Kita Tenggelam</h2> -->
            <div class="loadingContent" v-if="loading">
              <div class="l1"></div>
              <div class="l2"></div>
              <div class="l2"></div>
              <div class="l2"></div>
              <div class="l3"></div>
            </div>
            <div v-else-if="detail">
              <div class="articleContent" v-html="detail.content"/>
            </div>
            <div class="mapImg" v-if="detail">
              <img src="../assets/map-banjir.png">
            </div>
          </div>
        </div>
      </div>
      <div class="loadingQwe" v-if="loadingQwe"></div>
      <div class="qweCnt" v-else>
        <div :class="{qwe: true, qwe2: idx === 1}" v-for="(i, idx) in z" :key="i.id">
          <div class="profile">
            <div class="profilePict"
              :style="{'background-image': `url(${i.profilePict.imageSm})`}"></div>
            <div>
              <h4>{{i.name}}</h4>
              <div class="qweInfo">{{i.info}}</div>
            </div>
          </div>
          <div class="photoAlbum" ref="cntTypSc">
            <div class="photoSc">
              <div class="photoItem" v-for="p in i.photos" :key="p.id">
                <div class="thePhoto">
                  <img :src="p.media.imageSm" class="image">
                </div>
                <div class="caption" v-if="p.caption && p.caption !== ''">{{p.caption}}</div>
              </div>
            </div>
          </div>
          <!--
          <div class="viewMorePhoto btn"
            v-on:click="$router.push(`/beraksi/tenggelam-dalam-diam/${i.uri}/photos`)">
            <div class="btnL"></div>
            <div class="btnL2"></div>
            <span>Lihat foto lainya</span>
          </div>
          -->
        </div>
        <div class="abc">
          <div class="topBg"></div>
          <div :class="{theAbc: true, hasCd: !dateExpired}">
            <div class="ilustrasi"></div>
            <div class="abcCnt">
              <h4>Simak Kisah dan Pengalaman Lengkapnya dalam Pameran Virtual
                "Mengabarkan Kita Tenggelam"</h4>
              <div v-if="dateExpired">
                <div class="btn"
                  v-on:click="$router.push(`/beraksi/tenggelam-dalam-diam/pameran-virtual`)">
                  <div class="btnL"></div><div class="btnL2"></div>
                  <span>Masuk ke Pameran</span>
                </div>
              </div>
              <div class="cdCnt" v-else>
                <p>31 Juli 2021 17:00 WIB</p>
                <Countdown deadline="July 31, 2021 17:00:00"></Countdown>
                <a class="btn" :href="calUri" target="_blank">
                  <div class="btnL"></div><div class="btnL2"></div>
                  <span>Tambahkan ke Kalender</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="snackbar" v-if="snackbar">{{snackbar}}</div>
  </section>
</template>

<script>
import { DateTime } from 'luxon';
import Countdown from 'vuejs-countdown';
import Header from '@/components/Header.vue';

export default {
  name: 'home',
  components: { Header, Countdown },
  data() {
    return {
      snackbar: null,
      openDowloadOption: false,
      detail: null,
      z: [],
      loading: true,
      loadingQwe: true,
      options: {
        url: 'data-src',
        title: false,
        movable: false,
        zoomOnWheel: false,
        slideOnTouch: true,
      },
      dateExpired: true,
    };
  },
  methods: {
    startCallBack(x) {
      // console.log(x);
    },
    endCallBack(x) {
      // console.log(x);
    },
    viewMore(i) {
      this.$router.push(`/beraksi/tenggelam-dalam-diam/${this.z[i].uri}/photos`);
    },
    prevSlide(i) {
      let scLeft = this.$refs.cntTypSc[i].scrollLeft;
      scLeft -= 600;
      if (scLeft < 0) scLeft = 0;
      this.$refs.cntTypSc[i].scrollTo(scLeft, 0);
    },
    nextSlide(i) {
      let scLeft = this.$refs.cntTypSc[i].scrollLeft;
      scLeft += 600;
      if (scLeft > 1200) scLeft = 1200;
      this.$refs.cntTypSc[i].scrollTo(scLeft, 0);
    },
    calcCd() {
    },
  },
  computed: {
    video() {
      return this.$refs.video.player;
    },
    calUri() {
      const uri = 'https://calendar.google.com/calendar/u/0/r/eventedit?'
        + 'text=Pameran Virtual Mengabarkan Kita Tenggelam'
        + '&dates=20210731T100000.000Z/20210801T100000.000Z'
        + '&ctz=Asia/Jakarta'
        + '&details=Ikuti pameran virtual Mengabarkan Kita Tenggelam pada 31 Juli 2021 di '
        + `${escape('https://bumibutuhaksi.id/beraksi/tenggelam-dalam-diam')}`
        + `&location=${escape('https://bumibutuhaksi.id/beraksi/tenggelam-dalam-diam')}`
        // + '&pli=1'
        + '&uid=tenggelamdalamdiam';
        // + '&sf=true'
        // + '&output=xml';
      return uri;
    },
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Mengabarkan Kita Tenggelam - Bumi Butuh Aksi';
    this.$http.get(this.$config.uri('article/77/detail')).then((r) => {
      this.detail = (r.data.status === 200) ? r.data.data : null;
      this.loading = false;
    });
    this.$http.get(this.$config.uri('photographer/all?f=1')).then((r) => {
      this.z = (r.data.status === 200) ? r.data.data : [];
      this.loadingQwe = false;
    });
    this.calcCd();
  },
};
</script>


<style lang="scss">
  .cdCnt{
    margin-top: -24px;
    p{
      font-size: 24px;
      margin: 0 0 20px;
      @media (max-width: 680px) {
        font-size: 17px;
      }
    }
    .btn{
      margin-top: 20px;
    }
  }
  .tenggelamDalamDiam{
    .loadingContent{
      .l1{
        height: 30px;
        background-color: rgba(0,0,0,.1);
        width: 80%;
        margin-bottom: 10px;
      }
      .l2{
        height: 30px;
        background-color: rgba(0,0,0,.1);
        margin-bottom: 10px;
      }
    }
    .articleContent{
      font-size: 20px;
      line-height: 1.6;
      font-weight: 600;
      blockquote{
        font-size: 26px;
        line-height: 1.3;
        border-left: #ddd 4px solid;
        position: relative;
        margin: 26px 0;
        padding-bottom: 6px;
        color: #767676;
        padding-left: 50px;
        padding-left: 30px;
        &:before{
          content: "\"";
          font-size: 80px;
          position: absolute;
          left: 14px; top: -14px;
          display: none;
        }
      }
      p.caption{
        margin: -14px 0 20px 10px;
        font-size: 15px;
        line-height: 1.4;
        min-height: 22px;
      }

      p{
        margin: 0;
      }
      iframe.theMedia{
        border: none;
      }
      iframe.theMedia:not(.theEmbed){
        height: 420px;
        @media (max-width: 700px){
          height: 200px;
        }
      }
      .theMedia{
        display: block;
        margin: 20px 0;
        width: 100%;
        border-radius: 5px;
        position: relative;
        z-index: 3;
        &.md-wide{
          width: calc(100% + 200px);
          margin: 20px -100px;
          @media (max-width: 974px) {
            width: calc(100% + 100px);
            margin: 20px -50px;
          }
          @media (max-width: 874px) {
            width: calc(100% + 40px);
            margin: 20px -20px;
            border-radius: 0;
          }
        }
      }
    }
    @media (max-width: 700px) {
      .articleContent{
        font-size: 18px;
        line-height: 1.6;
      }
    }
  }
  .cdCnt{
    ul li{
      .digit{
        background-color: rgba(0,0,0,.1);
        padding: 8px 16px;
        border-radius: 5px;
        font-weight: 800;
        font-size: 60px;
        @media (max-width: 680px) {
          font-size: 26px;
          padding: 8px 8px 5px;
        }
      }
      .text{
        font-size: 14px;
        font-weight: 600;
        margin-top: 6px;
        @media (max-width: 680px) {
          font-size: 11px;
          margin-top: 4px;
        }
      }
      &:after{
        top: 14px;
        font-size: 46px;
        right: -15px;
        @media (max-width: 680px) {
          font-size: 30px;
          top: 5px; right: -14px;
        }
      }
    }
  }
</style>

<style scoped lang="scss">
  .loadingQwe{
    height: 800px;
    background-color: #fff;
    z-index: 9;
    position: relative;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 54px auto;
    background-image: url(../assets/loading-2.svg);
  }
  .theVideo{
    box-shadow: 4px 4px 0 #31c1f4;
  }
  .snackbar{
    position: fixed;
    bottom: 10px;
    left: 50%;
    background-color: rgba(0,0,0,.8);
    color: #fff;
    padding: 10px 20px;
    z-index: 999;
    border-radius: 6px;
    transform: translateX(-50%);
    @media (max-width: 680px) {
      left: 30px; right: 30px;
      transform: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .btn{
    background: #fff;
    border-radius: 50px;
    color: #444;
    box-shadow: none;
    font-weight: 600;
    padding: 10px 20px;
    font-size: 18px;
    padding-left: 52px;
    position: relative;
    transition: all .4s ease;
    cursor: pointer;
    span{
      position: relative;
      z-index: 2;
    }
    .btnL{
      width: 40px; height: 40px;
      border-radius: 50px;
      background-color: #444;
      position: absolute;
      left: 2px; top: 2px;
      transition: all .3s ease;
      background-image: url(../assets/right-arrow-notail-white.png);
      background-size: 20px auto;
      background-position: 10px 50%;
      background-repeat: no-repeat;
    }
    .btnL2{
      width: 40px; height: 40px;
      border-radius: 50px;
      position: absolute;
      left: 2px; top: 2px;
      transition: all .3s ease;
      background-image: url(../assets/right-arrow-notail-white.png);
      background-size: 20px auto;
      background-position: 10px 50%;
      background-repeat: no-repeat;
    }
    &:hover{
      color: #fff;
      .btnL{
        width: calc(100% - 4px);
      }
      .btnL2{
        left: 14px;
      }
    }
  }

  .abc{
    .topBg{
      position: absolute;
      top: -20px; right: 0; left: 0; height: 40px;
      background-image: url(../assets/flood-bg.png);
      background-size: 160% auto;
      background-position: top center;
      z-index: 9;
    }
    margin: 100px auto 0;
    background-image: url(../assets/wave.png);
    background-size: cover;
    background-position: top center;
    background-color: #c5a57c;
    box-sizing: border-box;
    height: 540px;
    position: relative;
    @media (max-width: 680px){
      height: 520px;
    }
    .theAbc{
      padding: 140px 0 0;
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      overflow: hidden;
      &.hasCd{
        padding-top: 50px;
      }
      @media (max-width: 680px){
        padding-top: 40px;
      }
    }
    .ilustrasi{
      width: 600px; height: 280px;
      position: absolute;
      right: -120px; bottom: 60px;
      background-image: url(../assets/ilustrasi-tenggelam.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @media (max-width: 680px){
        width: 400px; bottom: 0; right: -80px;
      }
    }
    .abcCnt{
      position: relative;
      z-index: 2;
      max-width: 840px;
      text-align: center;
      color: #fff;
      padding: 30px;
      border-radius: 3px;
      margin: 0 auto;
      h4{
        margin: 0 0 40px;
        font-size: 34px;
        font-weight: 800;
        @media (max-width: 680px){
          font-size: 22px;
        }
      }
    }
  }
  .qweCnt{
    background-color: #fff;
    position: relative;
    z-index: 3;
  }
  .qwe{
    max-width: 1300px;
    margin: 0 auto 20px;
    padding-bottom: 20px;
    // overflow: hidden;
    position: relative;
    @media (max-width: 1360px) {
      max-width: none;
      margin: 0 20px 20px;
    }
    &.qwe2{
      // border-top: #f4f6f1 30px solid;
      // margin-top: 60px;
    }
    .np{
      position: absolute;
      right: 20px; bottom: 26px;
      display: flex;
      @media (max-width: 680px) {
        display: none;
      }
      .np{
        position: static;
        width: 38px; height: 38px;
        box-sizing: border-box;
        border: #444 2px solid;
        border-radius: 50%;
        margin-left: 10px;
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .6;
        transition: opacity .3s ease;
        cursor: pointer;
        &:hover{
          opacity: 1;
        }
        &.p{
          background-image: url(../assets/left-arrow.png);
        }
        &.n{
          background-image: url(../assets/right-arrow.png);
        }
      }
    }
    .profile{
      position: relative;
      padding: 80px 20px 60px 360px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      max-width: 960px;
      margin: 0 auto;
      @media (max-width: 860px) {
        padding-left: 220px;
      }
      @media (max-width: 680px) {
        padding-left: 0; padding-right: 0;
        min-height: 70px;
        display: block;
      }
      .profilePict{
        position: absolute;
        width: 270px; height: 270px;
        border-radius: 50%;
        top: 50%; left: 20px;
        margin-top: -135px;
        background-color: #eee;
        background-position: center;
        background-size: cover;
        @media (max-width: 860px) {
          width: 160px; height: 160px;
          margin-top: 0;
          top: 90px;
        }
        @media (max-width: 680px) {
          width: 80px; height: 80px;
          position: static;
          margin-bottom: 14px;
        }
      }
      h4{
        margin: 0 0 16px;
        font-size: 46px;
        @media (max-width: 680px) {
          font-size: 18px;
        }
      }
      .qweInfo{
        white-space: pre-line;
        font-size: 17px;
        line-height: 1.5;
        color: #767676;
        @media (max-width: 680px) {
          font-size: 14px;
        }
      }
    }
    &.qwe2{
      .profile{
        padding-top: 40px;
        border-top: #eee 1px solid;
        margin-top: 40px;
        @media (max-width: 680px) {
          margin-top: 20px;
        }
      }
    }
    .photoAlbum{
      // overflow-x: scroll;
      // -ms-overflow-style: none;
      // scrollbar-width: none;
      // scroll-behavior: smooth;
      max-width: 920px;
      margin: 0 auto;
      &::-webkit-scrollbar {
        // display: none;
      }
      @media (max-width: 680px) {
        margin: 0 -20px;
        overflow-x: scroll;
        padding-left: 20px;
      }
      .photoSc{
        display: flex;
        margin: 0 -10px;
        // width: 2480px;
        // margin-left: 20px;
        // @media (max-width: 680px) {
        //   width: 1260px;
        // }
        @media (max-width: 680px) {
          width: 720px;
        }
      }
      .photoItem{
        // margin-right: 20px;
        width: calc(33.33333% - 20px);
        margin: 0 10px;
        @media (max-width: 680px) {
          // width: 300px;
          // margin-right: 14px;
        }
        .thePhoto{
          // height: 400px;
          // width: 600px;
          background-position: center;
          background-size: cover;
          // cursor: pointer;
          transition: all .2s ease;
          img{
            width: 100%;
          }
          &:hover{
          }
        }
        .caption{
          font-size: 14px;
          line-height: 1.2;
          padding: 7px 0 0 5px;
          margin-bottom: 10px;
          color: #767676;
          display: none;
          // white-space: nowrap;
          // overflow: hidden;
          // text-overflow: ellipsis;
          @media (max-width: 680px) {
            font-size: 12px;
          }
        }
      }
    }
    .viewMorePhoto{
      margin-top: 10px;
    }
  }


  .pageInfo{
    // background-image: url(../assets/kelas-iklim.jpg);
    background-size: cover;
    background-position: center;
    position: relative;
    margin-top: 80px;
    padding-top: 86vh;
    @media (max-width: 768px) {
      margin-top: 64px;
      padding-top: 56vw;
    }
    .loadingCoverImg{
      width: 100%;
      height: auto;
      margin: 0 auto;
      display: block;
      position: fixed;
      left: 0; top: 80px; right: 0;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 54px auto;
      background-image: url(../assets/loading-2.svg);
      height: calc(100vh - 80px);
      @media (max-width: 768px) {
        height: 56vw;
        top: 64px;
      }
    }
    .coverImg{
      width: 100%;
      height: auto;
      margin: 0 auto;
      display: block;
      position: fixed;
      left: 0; top: 80px; right: 0;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      background-color: #eee;
      height: calc(100vh - 120px);
      z-index: 1;
      @media (max-width: 768px) {
        height: 56vw;
        background-size: cover;
        top: 64px;
      }
    }
    .pageInfoWrapper2{
      overflow: hidden;
    }
    .pageInfoWrapper{
      max-width: none !important;
      background-color: #c5a57c;
      background-image: url(../assets/wave.png);
      // background-size: 1600px auto;
      background-size: cover;
      position: relative;
      z-index: 9;
      margin: 0 auto !important;
      padding: 80px 0 100px;
      @media (max-width: 860px) {
        padding: 40px 0 80px;
      }
      .topBg{
        position: absolute;
        top: -20px; right: 0; left: 0; height: 40px;
        background-image: url(../assets/flood-bg.png);
        background-size: 160% auto;
        background-position: top center;
      }
      .worCnt{
        max-width: 860px;
        margin: 0 auto;
        color: #fff;
        position: relative;
        .ilLeft{
          width: 120px; height: 120px;
          border-radius: 5px;
          position: absolute;
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          left: -200px;
          &.sendal{
            top: 60px;
            background-image: url(../assets/sandal.png);
          }
          &.boneka{
            top: 400px; left: -170px;
            background-image: url(../assets/boneka.png);
          }
          &.ranting{
            top: 800px;
            background-image: url(../assets/ranting-l.png);
          }
        }
        .ilRight{
          width: 120px; height: 120px;
          border-radius: 5px;
          position: absolute;
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          right: -200px;
          &.lemari{
            top: 40px;
            background-image: url(../assets/lemari.png);
            width: 160px; height: 160px;
          }
          &.botol{
            top: 360px;
            background-image: url(../assets/botol.png);
          }
          &.ranting{
            top: 760px;
            background-image: url(../assets/ranting-r.png);
          }
        }
        > ol > li{
          margin-bottom: 40px;
        }
        @media (max-width: 940px) {
          max-width: none;
          margin: 0 20px;
        }
      }
      .mapImg{
        margin-top: 30px;
        img{
          width: 100%; height: auto;
        }
      }
      iframe{
        width: 100%;
        height: 440px;
        @media (max-width: 768px) {
          height: 400px;
        }
        @media (max-width: 680px) {
          height: 180px;
        }
      }
      h2{
        max-width: 800px;
        margin: 0 auto 20px;
        font-size: 46px;
      }
      h4{
        margin: 40px auto 16px;
        font-size: 24px;
        max-width: 800px;
        line-height: 1.5;
      }
      p{
        margin: 0 auto 16px;
        max-width: 800px;
        font-size: 20px;
        line-height: 1.5;
        @media (max-width: 680px) {
          font-size: 19px;
          line-height: 1.4;
        }
      }
      a{
        color: #0b9a6b;
        text-decoration: none;
        font-weight: bold;
        &:hover{
          color: #32c1f4;
        }
        &.copy-hashtag{
          display: inline-block;
          padding-right: 30px;
          position: relative;
          // background-color: #eee;
          border-radius: 50px;
          padding-left: 6px;
          &:before{
            content: "";
            display: block;
            position: absolute;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            right: 0; top: 0;
            background-image: url(../assets/copy.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            background-color: #f9f9f9;
            &:before{
              background-image: url(../assets/copy-hover.png);
            }
          }
          &:active{
            background-color: #eee;
          }
        }
        &.ext-link{
          display: inline-block;
          padding-right: 30px;
          position: relative;
          // background-color: #eee;
          border-radius: 50px;
          padding-left: 6px;
          &:before{
            content: "";
            display: block;
            position: absolute;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            right: 0; top: 0;
            background-image: url(../assets/external-link.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            background-color: #f9f9f9;
            &:before{
              background-image: url(../assets/external-link-hover.png);
            }
          }
          &:active{
            background-color: #eee;
          }
        }
      }
      a.btn{
        color: #fff;
        margin-bottom: 20px;
        &:hover{
          color: #fff;
        }
      }
      ol{
        margin: 0;
        padding: 0;
        padding-left: 24px;
        font-size: 20px;
        &.a{
          list-style: lower-alpha;
        }
        li{
          margin: 0 0 10px;
        }
        h5{
          margin: 0 0 10px;
          font-size: 20px;
          font-weight: bold;
          line-height: 1.5;
        }
      }

      @media (max-width: 760px) {
        padding-top: 30px;
        .coverImg{
          margin-top: -30px;
        }
        h2{
          font-size: 50px;
          margin-left: -3px;
        }
        h4{
          font-size: 22px;
        }
      }
      @media (max-width: 680px) {
        h2{
          font-size: 38px;
          line-height: 1.3;
        }
      }
    }
  }
</style>
